/**
 * Formats an ISO date string into a readable format
 * @param {string} dateString - ISO date string e.g. "2026-03-24T00:00:00Z"
 * @param {object} options - optional Intl.DateTimeFormat options
 * @returns {string} e.g. "Mar 24, 2026"
 */
export const formatDate = (dateString, options = {}) => {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    const defaultOptions = {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      ...options,
    };
    return new Intl.DateTimeFormat('en-US', defaultOptions).format(date);
  } catch {
    return '';
  }
};

export const formatDateShort = (dateString) => {
  return formatDate(dateString, { month: 'short', day: 'numeric' });
};

export const formatDateMonthYear = (dateString) => {
  return formatDate(dateString, { month: 'long', year: 'numeric' });
};

export const formatDateRelative = (dateString) => {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const isSameDay = (a, b) =>
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate();

    if (isSameDay(date, today)) return 'Today';
    if (isSameDay(date, yesterday)) return 'Yesterday';
    return formatDateShort(dateString);
  } catch {
    return '';
  }
};
